import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const SuperUserRoute = ({ children, redirectTo = "/home" }) => {
  const { user, isAuthInitializing } = useContext(AuthContext);

  if (isAuthInitializing) {
    return null;
  }

  if (String(user?.role || "") !== "superUser") {
    return <Navigate to={redirectTo} replace />;
  }

  return children;
};

export default SuperUserRoute;
